import { render, staticRenderFns } from "./ProjectViewEmbed.vue?vue&type=template&id=06948741&scoped=true&"
import script from "./ProjectViewEmbed.vue?vue&type=script&lang=js&"
export * from "./ProjectViewEmbed.vue?vue&type=script&lang=js&"
import style0 from "./ProjectViewEmbed.vue?vue&type=style&index=0&id=06948741&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06948741",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VProgressCircular,VRow,VSpacer,VSwitch,VTooltip})
